import React, { useEffect } from 'react';
import {Button , makeStyles,Typography}from '@material-ui/core';
import Tables from '../components/DashBoard';
import {useLocation } from "react-router-dom";
import data from './topic.json';
import Topicpopup from './AddTopic';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
const axios = require("axios").default;
const headCells = [
  { id: 'topicid', numeric: false, disablePadding: true, label: 'Topic Id' },
  { id: 'title', numeric: true, disablePadding: false, label: 'Title' },
  { id: 'image', numeric: true, disablePadding: false, label: 'Image' },
{ id: ' ', numeric: true, disablePadding: false, label: ' ' },
 { id: '', numeric: true, disablePadding: false, label: '' },
];

const useStyles = makeStyles((theme) => ({
 root: {maxWidth:'1200px', padding:0, margin:'0 auto'},
title: {flex: '1 1 100%', padding: "34px", paddingLeft:'15px', fontSize: "40px", color: "black", lineHeight: ".78px"},
button: { height: "40px", margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf", textColor: "#fff", color: "white",
 paddingTop: "7px", paddingRight: "26px", paddingLeft: "13px", paddingBottom: "7px", fontSize: "13.7px", whiteSpace: "nowrap",
cursor: "pointer", borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { backgroundColor: "green", color: '#FFF' }},
viewButtonLabel: { padding:'30px', paddingLeft: "36px" },}));

 function EnhancedTable() {
   const classes = useStyles();
   const [close, setClose] = React.useState(0);
   const [articletemplate, setArticletemplate] = React.useState();
   const [openpopup, setOpenpopup] = React.useState(false);
   const [open, setOpen] = React.useState(false);
   const [topic, setTopic] = React.useState();
   const [edittopicdata, setEditTopicdata] = React.useState();
 const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let selectedCategoryId = useQuery().get("id");
React.useEffect(()=>{
 setTopic(data);
},[close]);

useEffect(()=>{
if(topic){
const value= topic.filter(val=>val.categoryid === +selectedCategoryId);
 setArticletemplate(value);
}
},[topic]);

const handleDeleteUser=(topicid)=>{
articletemplate.filter((n)=>n.topicId !==topicid );

};
 const handleEditTopic = (topicid) => {
const selectedtopic=articletemplate.filter((n)=>n.topicId === topicid);
setEditTopicdata(selectedtopic);
 setOpen(true);
    setOpenpopup(true);
};
const handleAdd=()=>{
setEditTopicdata();
 setOpen(true);
    setOpenpopup(true);
};
 const handleClose = () => {
  setClose(close+1);
    setOpen(false);
    setOpenpopup(false);
  };

  return (
    <div className={classes.root}>
      <br /><br /><br />
      <div style={{ display: "flex" }}>
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">Topics List</Typography>
        {openpopup ? (<Topicpopup open={open} handleClose={handleClose} edittopicdata={edittopicdata} selectedCategoryId={selectedCategoryId}
          articletemplate={articletemplate} />) : ("")}
        <Button className={classes.button} onClick={handleAdd} classes={{ label: classes.viewButtonLabel }}> ADD NEW Topics</Button>
      </div>
      {articletemplate ? <Tables handleDeleteUser={handleDeleteUser} handleEditTrivia={handleEditTopic} name={"topic"}
        headCells={headCells} articletemplate={articletemplate} placeholder={"Search for Topic ID …"} /> : ""}
    </div>
  );
}
export default (AuthenticatedPage()(EnhancedTable));